(function(){
  const root=document.documentElement;
  const qs=(s,c=document)=>c.querySelector(s);
  const qsa=(s,c=document)=>Array.from(c.querySelectorAll(s));

  function openMenu(){root.classList.add('ls-menu-is-open'); const b=qs('[data-ls-menu-open]'); if(b)b.setAttribute('aria-expanded','true'); const d=qs('#ls-menu-drawer'); if(d)d.setAttribute('aria-hidden','false');}
  function closeMenu(){root.classList.remove('ls-menu-is-open'); const b=qs('[data-ls-menu-open]'); if(b)b.setAttribute('aria-expanded','false'); const d=qs('#ls-menu-drawer'); if(d)d.setAttribute('aria-hidden','true');}
  function openSearch(){root.classList.add('ls-search-is-open'); const o=qs('[data-ls-search-overlay]'); if(o)o.setAttribute('aria-hidden','false'); setTimeout(()=>qs('.ls-search-overlay input')?.focus(),80);}
  function closeSearch(){root.classList.remove('ls-search-is-open'); const o=qs('[data-ls-search-overlay]'); if(o)o.setAttribute('aria-hidden','true');}

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-ls-menu-open]')) openMenu();
    if(e.target.closest('[data-ls-menu-close]')) closeMenu();
    if(e.target.closest('[data-ls-search-open]')) openSearch();
    if(e.target.closest('[data-ls-search-close]')) closeSearch();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeMenu(); closeSearch(); }});

  qsa('[data-ls-slider="hero"]').forEach(function(slider){
    const slides=qsa('[data-ls-slide]',slider); const dots=qsa('[data-ls-dot]',slider); let index=0;
    if(slides.length<2)return;
    function go(next){ index=(next+slides.length)%slides.length; slides.forEach((s,i)=>s.classList.toggle('is-active',i===index)); dots.forEach((d,i)=>d.classList.toggle('is-active',i===index)); }
    qs('[data-ls-slider-next]',slider)?.addEventListener('click',()=>go(index+1));
    qs('[data-ls-slider-prev]',slider)?.addEventListener('click',()=>go(index-1));
    dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));
    setInterval(()=>go(index+1),6500);
  });

  const cookie=qs('[data-ls-cookie]');
  if(cookie){
    if(localStorage.getItem('lsCookieAccepted')==='1') cookie.classList.add('is-hidden');
    qs('[data-ls-cookie-close]',cookie)?.addEventListener('click',()=>{localStorage.setItem('lsCookieAccepted','1');cookie.classList.add('is-hidden');});
  }
})();
